import { Box, Table, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { HeaderData } from 'modules/finance/components/FinancialWorkspace/types/table'

import { stickyColumnProps } from '../../const'
import { useComparisonHeaders } from '../../hooks/useComparisonHeaders'
import { STICKY_CELL_WIDTH } from '../Row/const'
import { HeaderCell } from './Cell'

interface Props {
  title: string
  isGrouped: boolean
  totalCount: number
  headers: string[] | HeaderData[]
}

export const ComparisonHeader = ({ headers, title, totalCount, isGrouped }: Props) => {
  const comparisonHeaders = useComparisonHeaders()

  const renderTitle = (withContent: boolean) => (
    <Table.HeadCell sticky={stickyColumnProps} style={{ minWidth: STICKY_CELL_WIDTH }}>
      {withContent && (
        <>
          <Text size="200" color="grey800" weight="medium">
            {title}
            {isGrouped && totalCount > 1 && <>&nbsp;·&nbsp;</>}
          </Text>
          {isGrouped && (
            <Box paddingTop="s2">
              <Text size="100" color="grey800" weight="medium">
                {i18n.t('finance.financial_workspace.breakdown_table.items_count', {
                  count: totalCount,
                })}
              </Text>
            </Box>
          )}
        </>
      )}
    </Table.HeadCell>
  )

  return (
    <>
      {comparisonHeaders ? (
        <Table.Row>
          {renderTitle(true)}
          {comparisonHeaders.map((header, index) => {
            return (
              <Table.HeadCell
                colSpan={3}
                justifyContent="center"
                key={`super-header-${index}`}
                style={{
                  borderRight:
                    index === comparisonHeaders.length - 1 ? undefined : '1px solid #E2E2E5',
                }}
              >
                <Text size="200" color="grey800" weight="medium">
                  {header.label}
                </Text>
              </Table.HeadCell>
            )
          })}
        </Table.Row>
      ) : null}
      <Table.Row>
        {renderTitle(!comparisonHeaders)}
        {headers.map((header, index) => {
          return (
            <HeaderCell
              key={index}
              header={header}
              withBorder={index !== headers.length - 1 && (index + 1) % 3 === 0}
            />
          )
        })}
      </Table.Row>
    </>
  )
}
